import React from "react";
import PublicLayout from "../../../layouts/user/PublicLayout";
import ListBerita from "../../../components/user/posts/ListBerita";
import BeritaPopuler from "../../../components/user/posts/BeritaPopuler";

function Blog() {
	return (
		<PublicLayout title="Berita" subtitle="Informasi terbaru seputar madrasah">
			<div className="flex flex-col lg:flex-row gap-8">
				<div className="w-full lg:w-[65%]">
					<ListBerita />
				</div>
				<div className="w-full lg:w-[35%]">
					<BeritaPopuler />
				</div>
			</div>
		</PublicLayout>
	);
}

export default Blog;
